import {DateTime} from "luxon";
import {capitalize} from "../../../../lib/TFICLib.ts";
import {toCentsFromMoney} from "../../../../lib/Money.ts";
import type {DrillDownLine} from "../../DrillDown/types/types.ts";
import type {PeriodicBalanceSheetRow} from "../types/periodicBalanceSheetTypes.ts";
import {ReportRowKind} from "../types/types.ts";
import type {MonthColumn} from "./periodicColumns.ts";

export function balanceColumnsForBuckets(
    buckets: {start_date: string; end_date: string}[],
): MonthColumn[] {
    return buckets.map((bucket) => {
        const end = DateTime.fromISO(bucket.end_date).setLocale("nl");
        const isMonthEnd = end.day === end.endOf("month").day;
        return {
            label: `Per ${end.toFormat("d MMMM yyyy")}`,
            shortLabel: isMonthEnd
                ? capitalize(end.toFormat("MMM yy"))
                : `${end.toFormat("d")} ${capitalize(end.toFormat("MMM yy"))}`,
        };
    });
}

export function linesUpTo(lines: DrillDownLine[], endDate: string): DrillDownLine[] {
    return lines.filter((line) => line.booking_date !== null && line.booking_date <= endDate);
}

export function isPeriodicCheckImbalanced(row: PeriodicBalanceSheetRow): boolean {
    return (
        row.kind === ReportRowKind.BalanceCheck &&
        [row.opening_balance, ...row.balances].some((money) => toCentsFromMoney(money) !== 0)
    );
}

export function hasBalanceSheetActivity(rows: PeriodicBalanceSheetRow[]): boolean {
    return rows.some(
        (row) =>
            row.kind === ReportRowKind.Account &&
            [row.opening_balance, ...row.balances].some((money) => toCentsFromMoney(money) !== 0),
    );
}
